import { FeatureContainer } from '../Containers/FeatureContainer';
import React from 'react';
import useStyle from './emptyDataMessage.style';

interface EmptyDataMessageProps {
  text: string;
  isVisible: boolean;
}
export const EmptyDataMessage = ({
  text,
  isVisible
}: EmptyDataMessageProps) => {
  const classes = useStyle();
  return (
    <>
      {isVisible && (
        <FeatureContainer>
          <h2 className={classes.root}>{text}</h2>
        </FeatureContainer>
      )}
    </>
  );
};
